import React, { useEffect, useState } from "react";
import { Typography, Tabel, Badge } from "../core";
import { Link } from "react-router-dom";
import { theme } from "../styles";
import { Menu, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { MixStyle } from "../styles";
import styled from "styled-components";
import EditDispatchModal from "./Modals/contract/editDispatchModal";
import EditClothReturnModal from "./Modals/contract/editClothReturnModal";

import { useHistory } from "react-router";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const { textColor } = theme;

const typoProps = {
  as: "h3",
  weight: "bold",
  letterSpacing: "0.2px",
  color: textColor.primary,
  text: "Dispatch History",
};
const TotalBillContainer = styled.div`
  max-width: 400px;
  margin: 20px 0px 0px auto;
  .b-b-2 {
    border-bottom: 2px solid #e7ecf4;
  }
  .f-between {
    ${MixStyle.flexBetween};
  }
  > div {
    padding: 15px;
    > span {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #233b67;
    }
  }
  .footer--div {
    ${MixStyle.flexBetween};
    background: #eff5fe;
    border-radius: 0px 0px 14px 14px;
  }
`;
const DispatchHistory = ({ dispatches, getDispatchesOfCurrentContract }) => {
  let history = useHistory();
  const [dispatchStats, setDispatchStats] = useState({
    totalKachiQuantity: 0,
    totalLshort: 0,
    totalRejection: 0,
    totalNetPass: 0,
  });
  const [modalState, setModalState] = useState({
    editDispatchModalOpen: false,
    editClothReturnModalOpen: false,
  });

  const [record, setRecord] = useState({});

  useEffect(() => {
    let totalKachiQuantity =
      dispatches.length > 0
        ? dispatches
            .map(({ kachiQuantity }) =>
              parseInt(kachiQuantity ? kachiQuantity : 0)
            )
            .reduce((acc, curr) => acc + curr)
        : 0;

    let totalLshort =
      dispatches.length > 0
        ? dispatches
            .map(({ lShort }) => parseInt(lShort ? lShort : 0))
            .reduce((acc, curr) => acc + curr)
        : 0;

    let totalRejection =
      dispatches.length > 0
        ? dispatches
            .map(({ glrReceived }) => parseInt(glrReceived ? glrReceived : 0))
            .reduce((acc, curr) => acc + curr)
        : 0;

    let totalNetPass = totalKachiQuantity - totalLshort - totalRejection;

    setDispatchStats({
      totalKachiQuantity,
      totalLshort,
      totalRejection,
      totalNetPass,
    });
  }, [dispatches]);

  const editDispatchModalOpenHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      editDispatchModalOpen: true,
    }));
    setRecord(record);
  };

  const editClothReturnModalOpenHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      editClothReturnModalOpen: true,
    }));
    setRecord(record);
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const goToGenrateInvoicePage = (record) => {
    history.push({
      pathname: "/generate-invoice",
      state: record,
    });
  };

  const menu = (index, record) => {
    return (
      <Menu>
        {record.invoiceStatus !== "generated" && (
          <Menu.Item onClick={() => editDispatchModalOpenHandler(record)}>
            Edit Dispatch
          </Menu.Item>
        )}
        {record &&
          record.packiParchiNumber &&
          record.invoiceStatus !== "generated" && (
            <Menu.Item onClick={() => editClothReturnModalOpenHandler(record)}>
              Edit Cloth Return
            </Menu.Item>
          )}
        {record &&
          record.status === "dispatchClosed" &&
          record.invoiceStatus === "pending" && (
            <Menu.Item onClick={() => goToGenrateInvoicePage(record)}>
              Generate Invoice
            </Menu.Item>
          )}
        {record &&
          record.status === "dispatchClosed" &&
          record.invoiceStatus === "generated" && (
            <Menu.Item>
              <Link to={`/print-invoice/${record._id}`}>Print Invoice</Link>
            </Menu.Item>
          )}
      </Menu>
    );
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      width: 150,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Date",
      dataIndex: "dispatchDate",
      key: "dispatchDate",
      render: (text, record, index) => {
        return (
          <span>
            {/* {record.invoice_date}
            <br /> */}
            {CHANGE_DATE_FORMAT.changeDateFormat(record.dispatchDate)}
          </span>
        );
      },
      width: 150,
    },

    {
      title: "Buyer C.N",
      dataIndex: "buyer_company_name",
      key: "buyer_company_name",
      width: 150,
    },
    {
      title: "K Quantity",
      dataIndex: "kachiQuantity",
      key: "kachiQuantity",
      width: 150,
    },

    {
      title: "L Short/Rejection",
      dataIndex: "lShort/glrReceived",
      key: "lShort/glrReceived",
      render: (text, record, index) => (
        <span>
          {record.lShort}/{record.glrReceived}
        </span>
      ),
      width: 150,
    },
    {
      title: "K Slip/P slip",
      dataIndex: "kachiParchiNumber/packiParchiNumber",
      key: "kachiParchiNumber/packiParchiNumber",
      width: 150,
      render: (text, record, index) => (
        <span>
          {record.kachiParchiNumber}/{record.packiParchiNumber}
        </span>
      ),
    },

    {
      title: "Rej-Date",
      render: ({ clothReturnDate }) => (
        <span>
          {clothReturnDate &&
            CHANGE_DATE_FORMAT.changeDateFormat(clothReturnDate)}
        </span>
      ),
      key: "clothReturnDate",
      width: 150,
    },

    {
      title: "Net Pass",
      render: ({ netPass }) => <span>{netPass}</span>,
      key: "netPass",
      width: 150,
    },
    {
      title: "Invoice Status",
      dataIndex: "invoiceStatus",
      key: "invoiceStatus",
      render: (invoiceStatus) => {
        console.log("invoiceStatus,", invoiceStatus);
        return (
          <Badge
            status={invoiceStatus === "generated" ? "Generated" : "pending"}
            text={invoiceStatus === "generated" ? "Generated" : "pending"}
          />
        );
      },
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 150,
      onCell: (record, rowIndex) => ({
        onClick: (e) => e.stopPropagation(),
      }),
      render: (text, record, index) => (
        <Dropdown
          overlay={() => menu(index, record)}
          onClick={(e) => e.stopPropagation()}
          trigger="click"
        >
          <MoreOutlined />
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <Typography {...typoProps} />

      <Tabel
        // loading={!dispatchHistory[0] ? true : false}
        padding="0px 10px"
        pagination={false}
        columns={columns}
        data={dispatches}
        // rowKey={({ dispatch_id }) => dispatch_id}
      />
      {dispatches.length !== 0 ? (
        <TotalBillContainer>
          <div className="f-between b-b-2">
            <Typography as="h6" noMargin color="#233B67" weight="500">
              Total Cloth Dispatch
            </Typography>
            <Typography as="h6" noMargin color="#404E67" weight="500">
              {dispatchStats.totalKachiQuantity}
            </Typography>
          </div>

          <div className="f-between b-b-2">
            <span>Total Rejection</span>
            <Typography
              as="h6"
              noMargin
              color="#404E67"
              weight="500"
              text={dispatchStats.totalRejection}
            />
          </div>
          <div className="f-between b-b-2">
            <span>Total L Short</span>
            <Typography
              as="h6"
              noMargin
              color="#404E67"
              weight="500"
              text={dispatchStats.totalLshort}
            />
          </div>

          <div className="footer--div">
            <Typography as="h6" noMargin color="#404E67" weight="500">
              Total Cloth Accept
            </Typography>
            <Typography as="h6" noMargin color="#404E67" weight="500">
              <span className="themed--color_pink">
                {dispatchStats.totalNetPass}
              </span>
            </Typography>
          </div>
        </TotalBillContainer>
      ) : null}

      {modalState.editDispatchModalOpen && (
        <EditDispatchModal
          editDispatchModal={modalState.editDispatchModalOpen}
          closeModal={closeModal}
          recordToEdit={record}
          getDispatchesOfCurrentContract={getDispatchesOfCurrentContract}
        />
      )}

      {modalState.editClothReturnModalOpen && (
        <EditClothReturnModal
          editClothReturnModal={modalState.editClothReturnModalOpen}
          closeModal={closeModal}
          recordToEdit={record}
          getDispatchesOfCurrentContract={getDispatchesOfCurrentContract}
        />
      )}
    </>
  );

  //   <EditDispatchInner
  //   dispatchId={dispatchId}
  //   onCreate={onCreate}
  //   onCancel={onCancel}
  //   form={form}
  // />
  // <EditClothReturn
  //   dispatchId={dispatchId}
  //   onCreate={onCreate}
  //   onCancel={onCancel}
  //   form={form}
  // />
};

export default DispatchHistory;
